import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  authStatus = new BehaviorSubject<boolean>(false);
  isInitializing = false;

  constructor(private http: HttpClient) { }

  async initialize(): Promise<void> {
    this.isInitializing = true;
    try {
      await firstValueFrom(this.http.get<any>(environment.apiUrl + `/user`));
      this.authStatus.next(true);
    } catch {
      // No valid session — remain unauthenticated
    } finally {
      this.isInitializing = false;
    }
  }

  setAuthenticated() {
    this.authStatus.next(true);
  }

  logout() {
    this.http.post(environment.apiUrl + '/auth/logout', {}).subscribe({ error: () => {} });
    this.authStatus.next(false);
  }

  isAuthenticated(): boolean {
    return this.authStatus.getValue();
  }

  statusChanged(): BehaviorSubject<boolean> {
    return this.authStatus;
  }

  async basicSignup(email: string, password: string): Promise<any> {
    const tokenResponse = await firstValueFrom(this.http.post<any>(environment.apiUrl + `/users/signup`, { email, password }));
    return tokenResponse;
  }

  async basic(email: string, password: string): Promise<any>  {
    try {
      return await firstValueFrom(
        this.http.post<any>(environment.apiUrl + `/auth/basic`, { email, password }).pipe(timeout(10000))
      );
    } catch (e: any) {
      if (e?.name === 'TimeoutError') {
        throw { message: 'Sign-in timed out. Please check your connection and try again.' };
      }
      throw e;
    }
  }
}
